export enum ClientInstallationStatusEnum {
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    ON_HOLD = 'ON_HOLD',
}
